import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

// Base schema with all fields
const SupportFolderSchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  name: z.string(),
  viewIds: z.array(zExt.objectId()),
  defaultViews: z.array(z.string()),
  user: zExt.objectId().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export const SupportFolderSchema: z.ZodType<SupportFolder> =
  SupportFolderSchema_;
export interface SupportFolder extends z.infer<typeof SupportFolderSchema_> {}

// Public view - accessible to all team members (user field is undefined)
const SupportFolderPublicViewSchema_ = SupportFolderSchema_.omit({
  user: true,
});

export const SupportFolderPublicViewSchema: z.ZodType<SupportFolderPublicView> =
  SupportFolderPublicViewSchema_;
export interface SupportFolderPublicView
  extends z.infer<typeof SupportFolderPublicViewSchema_> {}

// Private view - user-specific (user field is populated)
const SupportFolderPrivateViewSchema_ = SupportFolderSchema_;

export const SupportFolderPrivateViewSchema: z.ZodType<SupportFolderPrivateView> =
  SupportFolderPrivateViewSchema_;
export interface SupportFolderPrivateView
  extends z.infer<typeof SupportFolderPrivateViewSchema_> {}
